import Blue from '~/core';


new Blue({
  name: 'dialog modals',
  selector: '.dialog-modal',
  setup(dialog) {
    const closeBtn = dialog.querySelector('.dialog-modal__close i');
    
    this.$addEvents(closeBtn, 'click enter', () => {
      dialog.close();
    });
  },
});
new Blue({
  name: 'Generic Modal Trigger',
  selector: '.dialog-modal__trigger',
  setup(trigger) {
    const modalId = trigger.dataset.modalId;
    const modalDialog = document.getElementById(modalId);
    this.$addEvents(trigger, 'click.prevent enter.prevent', () => {
        modalDialog.show();
    });
  }
});